module.exports = __webpack_public_path__ + "fonts/fa-brands-400.4d95cd5.woff2";